module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-48.03c6767.woff2";